var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-text-center tw-p-5 tw-text-xl tw-font-bold"},[_vm._v("Impersonating...")])
}
var staticRenderFns = []

export { render, staticRenderFns }